export default "__VITE_ASSET__DmyNlb0N__"